module.exports = __webpack_public_path__ + "static/media/RethinktheInternetJacket.89940b36.jpg";